import { type CSSProperties } from 'react';

import { type Breakpoint } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import type { TErrorStyleProps } from '@/shared/errorText/types';

export const useStyles = makeStyles(({ spacing, typography, breakpoints }) => ({
  root: ({ lines }: TErrorStyleProps) => {
    const allowance = typeof lines === 'number' ? { default: lines } : lines;
    const lineHeight =
      typeof typography.caption.lineHeight === 'number' ? typography.caption.lineHeight : 0;

    return Object.entries(allowance).reduce(
      (memo, [key, value]) => {
        if (key !== 'default') {
          // eslint-disable-next-line no-param-reassign
          memo[breakpoints.only(key as Breakpoint)] = {
            minHeight: `${lineHeight * value}em`,
          };
        }

        return memo;
      },
      {
        display: 'block',
        marginLeft: spacing(2),
        minHeight: `${lineHeight * allowance.default}em`,
      } as Record<string, CSSProperties>,
    );
  },
  hidden: {
    visibility: 'hidden',
  },
}));
